type ImportFunction = () => Promise<any>;

interface RetryOptions {
  retries?: number;
  delay?: number;
}

export const retryImport = (
  importFunction: ImportFunction,
  options: RetryOptions = {},
): Promise<any> => {
  const { retries = 3, delay = 1000 } = options;

  return new Promise((resolve, reject) => {
    importFunction()
      .then(resolve)
      .catch((error) => {
        if (retries === 1) return reject(error);
        setTimeout(() => {
          retryImport(importFunction, { retries: retries - 1, delay })
            .then(resolve)
            .catch(reject);
        }, delay);
      });
  });
};
